<template>
	<article class="phoneInfo">
		<h6>비밀번호 변경</h6>
		<section class="phone_form">
			<div class="c_fieldArea">
				<FieldLayout title="새 비밀번호" :error="password_error">
					<InputPasswordLock
						:value="password"
						:class="{ error: password_error }"
						:show-error-icon="password_error"
						:placeholder="PLACEHOLDER_PASSWORD_REQUIREMENTS"
						:show-toggle="true"
						@input="onInputPw"
					/>
				</FieldLayout>
				<FieldLayout title="새 비밀번호 확인" :error="passwordRe_error">
					<InputPasswordLock
						:value="passwordRe"
						:placeholder="PLACEHOLDER_ENTER_NEW_PASSWORD_AGAIN"
						:show-toggle="true"
						:class="{ error: passwordRe_error }"
						:show-error-icon="passwordRe_error"
						@input="onInputPwRe"
					/>
				</FieldLayout>
				<button
					class="c_button radius-x-small primary-fill save"
					:disabled="!password || !passwordRe"
					@click="onClickChangePassword"
				>
					확인
				</button>
			</div>
		</section>
	</article>
</template>

<script setup lang="ts">
// component
import FieldLayout from '@/components/form/FieldLayout.vue';
// constant
import { PLACEHOLDER_ENTER_NEW_PASSWORD_AGAIN, PLACEHOLDER_PASSWORD_REQUIREMENTS } from '@/constants/title';

// validation
import InputPasswordLock from '../atom/input/InputPasswordLock.vue';

withDefaults(
	defineProps<{
		password: string;
		passwordRe: string;
		password_error?: string;
		passwordRe_error?: string;
	}>(),
	{}
);

const emit = defineEmits(['update:password', 'update:passwordRe', 'onClickChangePw']);
const onInputPw = (e: Event) => {
	const target = e.target as HTMLInputElement;
	emit('update:password', target.value);
};

const onInputPwRe = (e: Event) => {
	const target = e.target as HTMLInputElement;
	emit('update:passwordRe', target.value);
};
const onClickChangePassword = () => {
	emit('onClickChangePw');
};
</script>

<style lang="scss" scoped>
.phoneInfo {
	max-width: 40rem;
	margin: 0 auto;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: var(--space-xxx-large);
	.phone_form {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--space-x-large);
		p {
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-light);
			line-height: 2.3rem;
			text-align: center;
		}
		img {
			width: 12rem;
			height: auto;
		}
	}
	.c_fieldArea {
		gap: var(--space-xx-large);
		width: 100%;
		button {
			height: 4.8rem;
		}
	}
}
</style>
